import { PropsWithChildren, useEffect, useState } from 'react';

import { serverErrorService } from '@/services/ServerErrorService.ts';
import Page500 from '@/pages/CodeErrors/Page500.tsx';
import { ServerError } from '@/components/common/ServerError/ServerError.tsx';
import { ServerError as IServerError } from '@/api/config.ts';

const ErrorWrapper = ({ children }: PropsWithChildren) => {
  const errorCode = serverErrorService.getErrorCode();

  const [_, setError] = useState<IServerError | null>(null);
  const [toastError, setToastError] = useState<IServerError | null>(null);

  useEffect(() => {
    const unsubscribe = serverErrorService.subscribe((toastError, error) => {
      setToastError(toastError);
      setError(error);
    });

    return () => unsubscribe();
  }, []);

  const handleClose = () => serverErrorService.clearErrorToast();

  if (errorCode && errorCode >= 501) {
    return (
      <>
        <ServerError error={toastError} close={handleClose} />
        <Page500 />
      </>
    );
  }

  return (
    <>
      <ServerError error={toastError} close={handleClose} />
      {children}
    </>
  );
};

export default ErrorWrapper;
